export function isMeetingCancellation(itemClass: string | undefined): boolean {
    return !!(itemClass && itemClass.match(/^ipm\.schedule\.meeting\.canceled/i));
}
